import React from "react";
import PropTypes from "prop-types";
import { ActionsRow } from "@mc/mc-legacy";
import "./ListItem.scss";
import { Col, Row } from "reactstrap";
/**
 * Položka listu.
 */

class ListItem extends React.Component {
  static propTypes = {
    detail: PropTypes.bool,
    children: PropTypes.node,
    actions: PropTypes.func,
  };

  render() {
    const { detail, item, children, actions, md } = this.props;
    return (
      <Row className={`list-item ' ${detail ? "detail" : ""}`}>
        <Col md={md || 9} lg={12} className="pr-0">
          {children}
        </Col>
      </Row>
    );
  }
}

export default ListItem;
